import {
  BookingScheduleDto,
  BookingScheduleInterface
} from "../../../features/Booking-Form/typings/booking.types";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { SCHEDULE_QUERY_STALE_TIME_MS } from "./schedule-query-cache.constants";

type Params = {
  bookingScheduleDto: BookingScheduleDto;
  hasResourceLicense: boolean;
};

export function useRemoteFetchResourceSchedule(params: Params) {
  const { bookingScheduleDto, hasResourceLicense } = params;
  const { userIds, startDate, endDate } = bookingScheduleDto;

  return useRemoteQuery<BookingScheduleInterface[]>({
    queryKey: ["resourceSchedule", bookingScheduleDto],
    url: "/booking-schedule/resource",
    params: { userIds, startDate, endDate },
    enabled: !!startDate && !!endDate && hasResourceLicense,
    staleTime: SCHEDULE_QUERY_STALE_TIME_MS
  });
}
